import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reloadStatus: false,
  screenUiid: "",
  screenStatus: null,
  deviceStatus: null,
  isTroubleshootOpen: false,
  uploadPercent: 0,
  uploadFilename: "",
};

const reloadMetricsSlice = createSlice({
  name: "reloadMetrics",
  initialState,
  reducers: {
    reloadOn: (state, action) => {
      const { screen_uiid, screen_status, device_screen_status } = action.payload || {};

      state.reloadStatus = true;
      state.screenUiid = screen_uiid || "";
      state.screenStatus = screen_status || null;
      state.deviceStatus = device_screen_status || null;
    },

    reloadOff: (state) => {
      state.reloadStatus = false;
      state.screenUiid = "";
      state.screenStatus = null;
      state.deviceStatus = null;
    },

    openTroubleshoot: (state) => {
      state.isTroubleshootOpen = true;
    },

    closeTroubleshoot: (state) => {
      state.isTroubleshootOpen = false;
    },

    getContentUploadProgress: (state, action) => {
      const { progress, fileName } = action.payload || {};
      state.uploadPercent = progress || 0;
      state.uploadFilename = fileName || "";
    },

    resetContentUploadProgress: (state) => {
      return { ...state, uploadPercent: 0, uploadFilename: "" };
    }
  },
});

export const { reloadOn, reloadOff, openTroubleshoot, closeTroubleshoot, getContentUploadProgress, resetContentUploadProgress } = reloadMetricsSlice.actions;

export default reloadMetricsSlice.reducer;
